import { motion, useInView } from "framer-motion"
import { graphql, Link } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"

const Faqs = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const [accordianStates, setAccordianStates] = useState([0, 1])

  const toggleAccordian = index => {
    if (accordianStates.indexOf(index) > -1) {
      setAccordianStates(accordianStates.filter(i => i !== index))
    } else {
      setAccordianStates([...accordianStates, index])
    }
  }

  if (module.hideSection === "no") {
    return (
      <section
        className={`faq${module.extraClass ? ` ${module.extraClass}` : ""}`}
        id={module.extraId}
      >
        <div className="container-fluid">
          <div className="bg-white-100 py-60 lgscreen:py-30 pb-110 lgscreen:pb-30">
            <motion.div
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
            >
              <motion.div
                ref={ref}
                initial="hidden"
                animate={isInView || hasPlayed ? "show" : "hidden"}
                variants={sectionShow}
              >
                <div className="top-content relative w-full max-w-[960px] px-20 mx-auto text-center">
                  {module?.heading && (
                    <motion.h2 variants={animFade}>{module.heading}</motion.h2>
                  )}
                  {module?.description && (
                    <motion.div variants={animFade} className="content pb-30">
                      {parse(module.description)}
                    </motion.div>
                  )}
                </div>
                <div className="accordian-container mt-70 lgscreen:mt-25 px-80 lgscreen:px-40 mdscreen:px-20 relative">
                  <div className="flex flex-wrap gap-y-5 lgscreen:gap-y-4">
                    {module.faqs.map((item, i) => (
                      <motion.div
                        variants={animFade}
                        className="lg:w-6/12 w-full px-15"
                        key={i}
                      >
                        <div className="accordion">
                          <div
                            className={`accordion__item relative ${
                              accordianStates.indexOf(i) > -1 ? "open" : ""
                            }`}
                          >
                            {item?.title && (
                              <button
                                className="AccordionItemButton border-b-1 border-[#171515] border-opacity-50 w-full text-left pb-10 px-15 outline-none"
                                onClick={() => toggleAccordian(i)}
                                onKeyDown={() => toggleAccordian(i)}
                                aria-hidden="true"
                              >
                                <h5 className="text-17">{item.title}</h5>
                              </button>
                            )}
                            <div
                              className={`accordian-content-wrapper ${
                                accordianStates.indexOf(i) > -1
                                  ? ""
                                  : "collapsed"
                              }`}
                            >
                              {item?.description && (
                                <div className="accordian-content content pt-20 px-15">
                                  {parse(item.description)}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                  {module?.bookNow && (
                    <motion.div
                      variants={animFade}
                      className="flex justify-center mt-80 lgscreen:mt-40 w-full"
                    >
                      <Link
                        to={module.bookNow.url}
                        className="btn btn-black"
                        target={module.bookNow.target}
                      >
                        {module.bookNow.title}
                      </Link>
                    </motion.div>
                  )}
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
    )
  }
  return null
}

export default Faqs
export const EatDrinkFaqsFragment = graphql`
  fragment EatDrinkFaqsFragment on WpEatDrink_Restaurantcontent_RestaurantContent_Faqs {
    extraId
    extraClass
    hideSection
    heading
    description
    faqs {
      title
      description
    }
    bookNow {
      target
      title
      url
    }
  }
`
